export default __webpack_public_path__ + "static/media/talks.d0556905.svg";